module.exports = __webpack_public_path__ + "static/media/milton.1e337de4.jpeg";